import { useTranslations } from 'contexts/Translation'
import { HeaderBreadcrumbs, Spinner } from 'components'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams, useHistory } from 'react-router-dom'
import { FeatureAdvancedForm } from 'domains/Feature/components'
import { useGetFeatureInitialValues } from 'domains/Feature/hooks'
import { useDocument, useLoading } from 'hooks'
import { Spin } from '@qonsoll/react-design'

const FeatureEdit = (props) => {
  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const params = useParams()
  const { featureId } = params
  const [initialValues, loading] = useGetFeatureInitialValues(featureId)

  // [COMPONENT_STATE_HOOKS]

  // [COMPUTED_PROPERTIES]
  const headingProps = {
    title: t('Feature edit'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  // [HANDLERS]
  const handleBackButtonClick = () => history.goBack()

  return (
    <PageWrapper headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spin />
          </Col>
        ) : (
          <Col cw={[12, 12, 10, 8, 7]}>
            <FeatureAdvancedForm initialData={initialValues} />
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default FeatureEdit
